import { Store } from '@ngrx/store';
import { setDeserializedAppState } from 'Angular/state/app-state/app-state.actions';
import { SAVED_ITEM_DROPDOWN_OPTIONS } from 'Angular/features/components/saved-items/constants/saved-item-dropdown.constants';
import { FUND_CHART_APP_STATE_SLICE_KEY, FUND_CHART_SYSTEM_DEFAULT_STATE, SAVED_FUND_CHART_VIEW_STATE_KEYS, } from 'ChartApp/ts/features/fundamental-chart/constants';
import { SavedItemDropdownAction } from 'Angular/features/components/saved-items/enums/saved-item-dropdown-action.enum';
import { SavedItemType } from 'Angular/features/components/saved-items/enums/saved-item-type.enum';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { SavedFundChartService } from 'Angular/features/components/saved-items/services/saved-fund-chart.service';
import { PageToastMessagesService } from 'Angular/features/components/toast-messages/page-toast-messages-service';
import { UtilsService } from 'Angular/services/core/utils.service';
import { FundChartAppStateManager } from 'ChartApp/ts/apps/fund-chart/services/fund-chart-app.service';
import { SelectedFundChartService } from 'ChartApp/ts/apps/fund-chart/services/selected-fund-chart.service';
import { TemplateModalComponent } from 'Angular/features/components/modals/template-modal/template-modal.component';
import { FolderableSavedItemDropdownDirective } from 'FoldersApp/features/folders-shared/folderable-saved-item-dropdown/folderable-saved-item-dropdown.directive';
import deepEqual from 'Angular/utils/equal/deep-equal';
import { getSecurityPageType } from 'Angular/utils/security-utils';
import * as i0 from "@angular/core";
import * as i1 from "ChartApp/ts/apps/fund-chart/services/fund-chart-app.service";
import * as i2 from "ChartApp/ts/apps/fund-chart/services/selected-fund-chart.service";
import * as i3 from "Angular/features/components/saved-items/services/saved-fund-chart.service";
import * as i4 from "@ngrx/store";
import * as i5 from "Angular/features/components/toast-messages/page-toast-messages-service";
import * as i6 from "AccountsApp/ts/services/accounts.service";
import * as i7 from "Angular/services/core/utils.service";
import * as i8 from "FoldersApp/features/folders-shared/folderable-saved-item-dropdown/folderable-saved-item-dropdown.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/components/modals/template-modal/template-modal.component";
export class FundChartSavedItemDropdownComponent extends FolderableSavedItemDropdownDirective {
    get itemIsEdited() {
        if (this.state === null || this.state.chartId === null)
            return false;
        if (this.prevState === null)
            return true;
        return SAVED_FUND_CHART_VIEW_STATE_KEYS.some((key) => {
            const defaultValue = FUND_CHART_SYSTEM_DEFAULT_STATE[key] ?? '';
            const withDefault = (value) => (value === false ? false : value || defaultValue);
            const savedItemValue = withDefault(this.prevState[key]);
            const currStateValue = withDefault(this.state[key]);
            return !deepEqual(savedItemValue, currStateValue);
        });
    }
    constructor(appStateService, selectedFolderableService, savedItemService, store, toastMessagesService, accountsService, utilsService) {
        super(appStateService, savedItemService, selectedFolderableService, store, toastMessagesService);
        this.appStateService = appStateService;
        this.selectedFolderableService = selectedFolderableService;
        this.savedItemService = savedItemService;
        this.store = store;
        this.toastMessagesService = toastMessagesService;
        this.accountsService = accountsService;
        this.utilsService = utilsService;
        this.APP_STATE_SLICE_KEY = FUND_CHART_APP_STATE_SLICE_KEY;
        this.ITEM_ID_SLICE_KEY = 'chartId';
        this.SAVED_FUND_CHART_ITEM_TYPE = SavedItemType.FUND_CHART;
        this.BASE_DROPDOWN_OPTIONS = SAVED_ITEM_DROPDOWN_OPTIONS;
    }
    ngOnInit() {
        super.ngOnInit();
        this.securityPageType = getSecurityPageType();
    }
    dropdownOperationHandler(operation) {
        switch (operation) {
            case SavedItemDropdownAction.NEW_FROM_TEMPLATE:
                this.templateModal.openModal();
                break;
            case SavedItemDropdownAction.SAVE:
                this.updateSavedItem();
                break;
            case SavedItemDropdownAction.SET_AS_DEFAULT:
                this.setAsDefault();
                break;
            case SavedItemDropdownAction.CLOSE:
                this.close();
                break;
            case SavedItemDropdownAction.COPY_STATE:
                this.copyStateToClipboard();
                break;
            default:
        }
    }
    selectTemplate(templateObject) {
        this.selectedFolderableService.clearSelection();
        this.store.dispatch(setDeserializedAppState({ deserializedAppState: templateObject.state }));
    }
    setAsDefault() {
        let params;
        if (this.securityPageType) {
            params = {
                [`default_${this.securityPageType}_fund_chart`]: { ...this.state },
            };
        }
        else {
            params = { default_fund_chart: { ...this.state } };
        }
        this.accountsService.putUserPreferences(params).subscribe();
    }
    copyStateToClipboard() {
        if (this.state === null)
            return;
        this.utilsService.copyStateDataToClipboard(this.state, SAVED_FUND_CHART_VIEW_STATE_KEYS, FUND_CHART_SYSTEM_DEFAULT_STATE);
    }
}
FundChartSavedItemDropdownComponent.ɵfac = function FundChartSavedItemDropdownComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartSavedItemDropdownComponent)(i0.ɵɵdirectiveInject(i1.FundChartAppStateManager), i0.ɵɵdirectiveInject(i2.SelectedFundChartService), i0.ɵɵdirectiveInject(i3.SavedFundChartService), i0.ɵɵdirectiveInject(i4.Store), i0.ɵɵdirectiveInject(i5.PageToastMessagesService), i0.ɵɵdirectiveInject(i6.AccountsService), i0.ɵɵdirectiveInject(i7.UtilsService)); };
FundChartSavedItemDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartSavedItemDropdownComponent, selectors: [["ycn-fund-chart-saved-item-dropdown"]], viewQuery: function FundChartSavedItemDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(TemplateModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateModal = _t.first);
    } }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 8, consts: [[3, "dropdownOperation", "itemType", "itemTypeDescription", "defaultName", "ancestorFolderId", "itemIsEdited", "nameMaxLength", "dropdownOptions"], [3, "templateSelectionHandler", "itemType"]], template: function FundChartSavedItemDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-folderable-saved-item-dropdown", 0);
        i0.ɵɵlistener("dropdownOperation", function FundChartSavedItemDropdownComponent_Template_ycn_folderable_saved_item_dropdown_dropdownOperation_0_listener($event) { return ctx.dropdownOperationHandler($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "ycn-template-modal", 1);
        i0.ɵɵlistener("templateSelectionHandler", function FundChartSavedItemDropdownComponent_Template_ycn_template_modal_templateSelectionHandler_1_listener($event) { return ctx.selectTemplate($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("itemType", "saved_fundamental_chart")("itemTypeDescription", "fundamental chart")("defaultName", "New Fundamental Chart")("ancestorFolderId", ctx.ancestorFolderId)("itemIsEdited", ctx.itemIsEdited)("nameMaxLength", 200)("dropdownOptions", ctx.dropdownOptions);
        i0.ɵɵadvance();
        i0.ɵɵproperty("itemType", ctx.SAVED_FUND_CHART_ITEM_TYPE);
    } }, dependencies: [i8.FolderableSavedItemDropdownComponent, i9.TemplateModalComponent], encapsulation: 2 });
